import { CALLING_VENDOR_TYPE } from '../components/CommunicationHistory/type';

export interface ISystemInteraction {
  data: Array<ISystemInteractionData>;
  pages: IPageable;
}

export interface IPageable {
  pageNo: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

export interface ISystemInteractionData {
  communicationTemplateName: string;
  communicationTemplateData: any;
  scheduledTimestamp: string;
  status: string;
  communicationType: string;
  communicationStage: string;
  phoneNumber: string;
  email: string;
  notificationToken: string;
  sentAt: string;
}

export interface ICallInteraction {
  data: Array<ICallInteractionData>;
  pages: IPageable;
}

export interface IFieldCallInteractionData {
  callId: string;
  phoneNumber: string;
  createdAt: string;
  providerType: CALLING_VENDOR_TYPE;
  agentPhoneNumber: string;
  customerPhoneNumber: string;
  callStatus: string;
  recordingData: {
    url: string;
    durationInSeconds: string;
  };
}

export interface IFieldCallInteraction {
  data: Array<IFieldCallInteractionData>;
  pages: IPageable;
}

export interface ICallInteractionData {
  referenceId: string;
  type: string;
  accountNumber: string;
  createdAt: string;
  metadata: any;
  sourceType: string;
  answerViews: AnswerView[];
  imageUrls: string[];
  agentReferenceId: string;
  source: Address;
  isDetailRow?: boolean;
  toggleState?: boolean;
}

export interface AnswerView {
  interactionId?: string;
  referenceId?: string;
  questionReferenceId?: string;
  questionName?: string;
  questionText?: string;
  answerType?: AnswerType;
  interactionLevel?: number;
  hierarchyTag?: string;
  optionReferenceId?: string;
  optionText?: string;
  inputAmount?: number;
  inputDate?: string;
  inputText?: string;
  questionTag?: keyof typeof QuestionTags;
  metadata?: Record<string, string | number>;
}

export enum AnswerType {
  TEXT = 'TEXT',
  DATE = 'DATE',
  TIME = 'TIME',
  AMOUNT = 'AMOUNT',
  OPTIONS = 'OPTIONS',
  REMINDER = 'REMINDER',
  RADIO_OPTIONS = 'RADIO_OPTIONS',
  MULTI_IMAGE_UPLOAD = 'MULTI_IMAGE_UPLOAD',
  GROUPED_OPTIONS = 'GROUPED_OPTIONS',
  CHECKBOX_OPTIONS = 'CHECKBOX_OPTIONS',
  MULTI_AUDIO_UPLOAD = 'MULTI_AUDIO_UPLOAD'
}

export enum QuestionTags {
  IMAGE_UPLOAD = 'IMAGE_UPLOAD'
}

export interface Address {
  referenceId: string;
  addressReferenceId: string;
  lineOne: string;
  lineTwo: string;
  city: string;
  state: string;
  pinCode: string;
  current: boolean;
  permanent: boolean;
  type: string;
  source: string;
  addressQualityStatus: string;
  new?: boolean;
  recipientNumber?: number;
  addressGood: boolean;
  ingestionDate: string;
}
